import { useCallback, useMemo } from 'react';

import { Translate, useLanguage } from '@spazious/dollhouse-i18n';
import { useStore } from '@spazious/dollhouse-store';
import { Flex } from '@spazious/dollhouse-uikit';
import { ChoiceButton, Typography } from '@spazious/dollhouse-uikit';

export const LanguageSelector = () => {
  const { locale, languages } = useLanguage();
  const set = useStore(({ set }) => set);

  const formattedLanguages = useMemo(
    () =>
      Object.keys(languages).map((option) => ({
        label: languages[option as keyof typeof languages],
        value: option,
      })),
    [languages]
  );

  const handleLanguageChange = useCallback(
    (lang: string) => {
      set({ language: lang });
    },
    [set]
  );
  return (
    <Flex column gap="var(--spacing-gap)">
      <Typography size="large" variant="title">
        <Translate>Language</Translate>
      </Typography>
      <Flex flexWrap="wrap" gap="var(--spacing-gap)" justifyContent="space-between">
        {formattedLanguages.map((lang) => (
          <ChoiceButton
            key={lang.value}
            checked={locale === lang.value}
            name="language"
            option={lang}
            onChange={handleLanguageChange}
          />
        ))}
      </Flex>
    </Flex>
  );
};
